import React from 'react';
import { ChoiceList } from 'Components/frameworks/choice-list/ChoiceList';
import { ChoiceLists } from 'Components/frameworks/choice-lists/ChoiceLists';
import { COUNTRIES_FACET_ID } from 'Utils/faceting/constants';
import { badgeHasIconName } from 'Src/types/widget-helpers';
import { getChoices } from './FacetList.utils';
type Props = {
  activeCustomFacets: any;
  activeFacets: any;
  capitalizeLabels?: boolean;
  title?: string;
  name: string;
  facets: Array<SearchFacetList>;
  className?: string;
  onChange: (name: string, checked: boolean, value: string | boolean) => void;
  isTopFacets?: boolean;
  isWorldMapFullScreen?: boolean;
};

const getChoiceLists = (props: Props) => {
  // Safeguard: API can return facets with null names, that must be ignored.
  return props.facets
    ?.filter(({ badgeIconProps, label }) => Boolean(badgeHasIconName(badgeIconProps) || label))
    .map((facet) => {
      const { label, value } = facet;
      return {
        choices:
          facet.list && facet.list.length > 0 ? getChoices({ ...props, facets: facet.list }) : [],
        label,
        value,
      };
    });
};

export const FacetList = (props: Props) => {
  const { name, isTopFacets } = props;
  return !isTopFacets && name === COUNTRIES_FACET_ID ? (
    <ChoiceLists
      choiceLists={getChoiceLists(props)}
      className={props.className}
      name={name}
      onChange={props.onChange}
      title={props.title}
    />
  ) : (
    <ChoiceList
      choices={getChoices(props)}
      className={props.className}
      name={name}
      onChange={props.onChange}
      title={props.title}
    />
  );
};
